var chunkToChildrenMap = {
	"5385": [
		8845,
		1439,
		5534,
		1869,
		1228,
		2702
	]
};
__webpack_require__.f.preload = (chunkId) => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.G);
};